import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=0598bc6c&"
import script from "./standard.vue?vue&type=script&lang=ts&"
export * from "./standard.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/scss/grid.scss?vue&type=style&index=0&lang=scss&module=styleGrid&"
import style1 from "../../assets/scss/mobile/grid.scss?vue&type=style&index=1&lang=scss&module=styleMobileGrid&"
import style2 from "./standard.vue?vue&type=style&index=2&lang=scss&module=true&"




function injectStyles (context) {
  
  this["styleGrid"] = (style0.locals || style0)
this["styleMobileGrid"] = (style1.locals || style1)
this["$style"] = (style2.locals || style2)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/home/bitrix/www/frontend/components/video/video.vue').default})
